import { Button, Grid, Typography } from '@mui/material';
import React from 'react';

/**
 * Nav button used as a child of `NavBar`.
 *
 * @param props - The component props.
 * @param props.label - Text shown.
 * @param props.onClick - Handler fired when the button is clicked.
 * @returns The rendered link button.
 */
export function NavBarItem({
  icon,
  label,
  onClick,
}: {
  icon?: React.ReactNode;
  label: string;
  onClick: () => void;
}) {
  return (
    <Button onClick={onClick} startIcon={icon}>
      <Typography variant="lg" sx={{ color: 'black' }}>
        {label}
      </Typography>
    </Button>
  );
}

/**
 * NavBar with actionable buttons for Meiji features.
 *
 * @param props - The component props.
 * @param props.children - `NavBarItem` elements to render in the NavBar;
 *   any other child type is ignored.
 * @returns The rendered NavBar.
 */
export function NavBar({ children }: { children?: React.ReactNode }) {
  return (
    <Grid
      data-test-id="nav-bar-selector"
      container
      justifyContent="space-between"
      alignItems="center"
    >
      {React.Children.map(children, (child, index) => {
        // NavBar only accepts <NavBarItem> children
        if (!React.isValidElement(child) || child.type !== NavBarItem) {
          return null;
        }

        return (
          <Grid item key={index}>
            {child}
          </Grid>
        );
      })}
    </Grid>
  );
}
